import {
  ApiDeleteGalGame,
  ApiGetGalGame,
  ApiGetGalGamePage,
  ApiGetMateGalGamePage,
  ApiPostCloneGalGame,
  ApiPostGalGame,
} from "@/apis/gal-game";
import { defineStore } from "pinia";
import { showLoadingToast, showSuccessToast } from "vant";
import { useMate } from "./mate";
import i18n from "@/locales";
import { useReply } from "./reply";
import { GalGame } from "@/types/galGameEditor";

export const useGalGameHome = defineStore("gal-game-home", {
  state: () => ({
    activeTab: "recommend" as "recommend" | "latest",
    gameMap: {} as Record<number, GalGame>,
    activeGameUUID: "",
    activeGame: {} as GalGame,
    gameDetailMap: {} as Record<string, GalGame>,
    plaza: {
      1: [] as number[], // 恋爱类
    },

    activeCreateTab: 1 as 1 | 2,
    create: {
      1: [] as number[], // 已发布
      2: [] as number[], // 未发布
    },
    discoverList: {
      // 推荐
      recommend: {
        scrollTop: 0,
        list: [] as number[],
      },
      // 最新
      latest: {
        scrollTop: 0,
        list: [] as number[],
      },
    }, // 最新
    isLoadingNewList: false,
    played: {},
    scrollTop: {
      0: 0, // 游戏广场
      1: 0, // 我的创作
    },
    isInit: false,
  }),
  getters: {
    createCurrentList(state) {
      return state.create[state.activeCreateTab];
    },
    discoverCurrentList(state) {
      return state.discoverList[state.activeTab];
    },
  },
  actions: {
    async initHome(force?: boolean) {
      if (this.isInit && !force) return;
      this.isInit = true;
      this.initCreate();
      this.fetchDiscoverList();
    },
    async initCreate(id?: number) {
      id = id || useMate().currentMate?.id || 0;
      if (!id) return;
      const { page } = await ApiGetMateGalGamePage(id);
      this.create[1] = [];
      this.create[2] = [];
      for (const game of page.data) {
        this.gameMap[game.id] = game;
        this.create[game.status as 1 | 2].push(game.id);
      }
    },
    async fetchDiscoverList() {
      const { list } = this.discoverCurrentList;
      const pageNum = list.length / 6 + 1;
      if (!Number.isInteger(pageNum)) return false;
      this.isLoadingNewList = true;
      const { page } = await ApiGetGalGamePage(
        { tab: this.activeTab === "recommend" ? "hot" : undefined },
        { page: pageNum, perPage: 6 }
      );
      this.isLoadingNewList = false;
      const tmpList = page.data
        .map((game: GalGame) => {
          this.gameMap[game.id!] = game;
          return game.id!;
        })
        // 随机排序
        .sort(() => Math.random() - 0.5);

      this.discoverCurrentList.list = [...list, ...tmpList];
      if (list.length === page.total) return false;
      return page.data.length === 6;
    },
    async createGame(name: string) {
      const toast = showLoadingToast(i18n.global.t("Message.creating"));
      const { item } = await ApiPostGalGame({
        name,
        mateId: useMate().currentMate!.id!,
      });
      toast.close();
      this.initCreate();
      return item;
    },
    async cloneGame(id: number) {
      const toast = showLoadingToast(i18n.global.t("Message.importing"));
      const { item } = await ApiPostCloneGalGame(id);
      toast.close();
      this.initCreate();
      return item;
    },
    async deleteGame(id: number) {
      const { code } = await ApiDeleteGalGame(id);
      if (code === 200) {
        showSuccessToast(i18n.global.t("Message.deleteSuccessful"));
        this.initCreate();
      }
    },
    async getOrFetchGame(uuid: string, force?: boolean) {
      const game = this.gameDetailMap[uuid];
      if (game) this.activeGame = game;
      const { item } = await ApiGetGalGame(uuid);
      this.gameDetailMap[item.uuid] = item;
      this.activeGame = this.gameDetailMap[uuid];
      const replyStore = useReply();
      replyStore.updateMap([this.activeGame.reply as any]);
      if (replyStore.getReply(this.activeGame.replyId!))
        this.activeGame.reply = replyStore.getReply(this.activeGame.replyId!);
      return this.activeGame;
    },
  },
});
